// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Ue00","row":"ProcedureTreatmentSummary_row__2b9zV"};